const required_fields = [
   "first_name",
   "last_name",
   "email_address",
   "user_type",
   "company"
]

export default required_fields